import React, { useState } from 'react';
import { Container, TabContent, TabPane } from 'reactstrap';
import Loading from '../../shared/components/custom/Loading';
import { partial } from '../../util/translation/translation';
import NavTab from '../../shared/components/custom/NavTab';
import LotteryList from './components/LotteryList';
import LotteryPrizeList from './components/LotteryPrizeList';
import LotteryShowcase from './components/LotteryShowcase';

const LotteryListPage = () => {
  const [loadingLotteryList, setLoadingLotteryList] = useState(true);
  const [loadingPrizes, setLoadingPrizes] = useState(true);
  const [tab, setTab] = useState(1);
  const p = partial('lotteries');

  return (
    <Container>
      <Loading loading={loadingLotteryList || loadingPrizes} />
      <LotteryShowcase />
      <NavTab
        activeTab={tab}
        tabs={[p('lottery'), p('prizes')]}
        setTab={setTab}
      />
      <TabContent activeTab={tab}>
        <TabPane tabId="1">
          <LotteryList setLoading={setLoadingLotteryList} />
        </TabPane>
        <TabPane tabId="2" className="m-3">
          <LotteryPrizeList setLoading={setLoadingPrizes} />
        </TabPane>
      </TabContent>
    </Container>
  );
};

export default LotteryListPage;
